import styled, { css } from 'styled-components';

const GreetingCardEmptyWrapper = styled.div(
  ({ giftWrapperUrl }) => css`
    background: url(${giftWrapperUrl}) center center;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    display: flex;
    flex: unset;
    flex-direction: column;
    height: 519px;
    margin-top: 43px;
    overflow: hidden;
    padding-left: 0px;
    padding-top: 90px;
    position: relative;
  `
);

const ExperienceBow = styled.div(
  ({ theme: { images } }) => css`
    background: url(${images.experienceBow}) no-repeat center center;
    background-size: 350px 350px;
    border-radius: 24px;
    display: flex;
    flex: unset;
    flex-direction: column;
    height: 300px;
    margin-top: 16px;
    overflow: hidden;
    position: relative;
    width: 250px;
  `
);

export { ExperienceBow, GreetingCardEmptyWrapper };
